import React, { Component } from 'react'
import {connect } from 'react-redux'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import requisitionFormStyle from '../../assets/jss/requisitionFormStyle'
import PositionInformationForm from '../form/PositionInformationForm'
import { 
    selectJobCategory,
    handleDelete,
    getEntities,
    getJobCategories
} from '../../actions/PositionInformationActions'
import {
    onChangeJobDescription,
    onChangeJobRequirment
} from '../../actions/RequisitionActions'
import * as Sentry from '@sentry/browser'

Sentry.init({
   dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class PositionInformation extends Component {

    constructor(props) {
        super(props)

        this.state ={
            required_job_requirment: false,
            required_job_description: false,
            requried_category: false,
        }

    }

    componentDidMount() {
        this.props.getEntities()
        this.props.getJobCategories()
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }
    
    render() {

        const { 
                classes, 
                chooseJobCategory, 
                requisition_data, 
                // next, 
                // back
            } = this.props
        const { 
            category, 
            entities, 
            category_list
        } = requisition_data.requisition
        
        return (
            <div className={classes.main}>
                
                <PositionInformationForm 
                    chooseCategory={chooseJobCategory} 
                    categories={category}
                    category_list= {category_list}
                    deleteCatetory={this.onDeleteCategory}
                    entities = {entities}
                    onSubmit = {this.nextPage}
                    // onSubmit={next}
                    // next={next}
                    // back={back}
                    requiredCategory = {this.state.requried_category}
                    requireJobDescription = {this.state.required_job_description}
                    requireJobRequirment = {this.state.required_job_requirment}
                    onChangeJobDescription={this.props.onChangeJobDescription}
                    onChangeJobRequirment={this.props.onChangeJobRequirment}
                    contract={requisition_data.form.PositionInformation === undefined ? "unselected": undefined} //requisition_data.form.PositionInformation.values.contract
                />
            </div>
        )
    }

    onDeleteCategory = category => () => {

        this.props.handleDelete(category)

    }

    nextPage = () => {

        const {
            job_description,
            job_requirment,
            category
        } = this.props.requisition_data.requisition

        if(job_description.length === 0) {
            this.setState({
                required_job_description: true
            })
        } else if(category.length === 0) {
            this.setState({
                requried_category: true
            })
        }else if(job_requirment.length === 0) {
            this.setState({
                required_job_requirment: true
            })
        }else{
            this.setState({
                required_job_description: false,
                required_job_requirment: false,
                requried_category: false
            })
            this.props.next()
        }
    }

}


PositionInformation.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch) => ({
    chooseJobCategory: (category) => {
        dispatch(
            selectJobCategory(category)
        )
    },
    handleDelete: (categories) => {
        dispatch(
            handleDelete(categories)
        )
    },
    getEntities: () => {
        dispatch(
            getEntities()
        )
    },
    getJobCategories: () => {
        dispatch(
            getJobCategories()
        )
    },
    onChangeJobDescription: (text) => {
        dispatch(
            onChangeJobDescription(text)
        )
    },
    onChangeJobRequirment: (text) => {
        dispatch(
            onChangeJobRequirment(text)
        )
    }
})

const mapStateToProps = state => ({
    requisition_data: state
})


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(requisitionFormStyle)(PositionInformation))